import { SitemapItem } from './sitemap-item'
import { ViewHeaderDescription } from './view-header-description'

export class ViewItem extends SitemapItem {
  public entity: string
  public viewName: string
  public msProvider: string
  public formName: string
  public viewHeaderDescription?: ViewHeaderDescription

  constructor(model: ViewItem) {
    super(model)
    this.entity = model.entity
    this.viewName = model.viewName
    this.msProvider = model.msProvider
    this.formName = model.formName
    this.viewHeaderDescription = model.viewHeaderDescription
  }
}
